import { jsUrl } from "@/const";
export const openLink = (url, cb) => {
  window.open(jsUrl + url, "_blank");
  cb && cb();
};